<template>
  <v-toolbar
    fixed
    app
    light
    flat
    style="border-bottom: 1px solid #e0e0e0; background-color: white;"
  >
    <progress-bar :show="busy"></progress-bar>
    <v-toolbar-side-icon
      @click.stop="toggleDrawer"
      v-if="authenticated"
    ></v-toolbar-side-icon>
    <v-toolbar-title class="mr-2 pl-0">
      <template v-if="authenticated"> </template>
      <template v-else>
        <router-link
          to="/"
          exact
          class="text--lighten-2 hidden-sm-and-down"
          style="min-width: 500px;"
        >
          <img
            src="/img/logosmoll.png"
            alt="Lokales Handwerk"
            class="mt-2 ml0 pa-0"
            style="height: 55px; width: 243px;"
          />
        </router-link>
        <router-link
          to="/"
          exact
          class="text--lighten-2 hidden-md-and-up hidden-print-only"
          style="min-width: 50px;"
        >
          <img
            src="/img/logo_mini_trans.png"
            alt="Lokales Handwerk Logo"
            class="mt-2 ml-0 pl-0"
            style="width: 50px; height: 50px;"
          />
        </router-link>
      </template>
    </v-toolbar-title>
    <div class="hidden-sm-and-down">
      <ToolbarSuchbegriff
        class="ml-3"
        v-if="this.$store.state.route.path == '/lokal' &&
            $store.state.suche.betriebe.length > 0"
      ></ToolbarSuchbegriff>
      <toolbar-leistungswitch
        class="ml-3"
        v-if="this.$store.state.route.path == '/handwerker'"
      ></toolbar-leistungswitch>
    </div>
    <v-spacer></v-spacer>
    <!-- <v-btn @click="busy = !busy">toglle</v-btn> -->
    <toolbar-suche
      v-if="this.$store.state.route.path == '/lokal' &&
          $store.state.suche.betriebe.length > 0"
    ></toolbar-suche>

    <toolbar-gemerkt
      xxv-if="this.$store.getters.gemerktzahl"
      class="mr-2"
    ></toolbar-gemerkt>

    <template v-if="authenticated">
      <toolbar-nachrichten class="mr-2"></toolbar-nachrichten>
    </template>

    <v-toolbar-items>
      <!-- Authenticated -->
      <template v-if="authenticated">
        <v-btn flat :to="{ name: 'einstellungen.profil' }">
          {{ user.name }}
        </v-btn>
        <!-- <v-btn flat @click.prevent="logout">{{ $t('logout') }}</v-btn> -->
        <!-- <v-btn flat @click.prevent="logout"><v-icon>exit_to_app</v-icon></v-btn> -->
      </template>

      <!-- Guest -->
      <template v-else>
        <v-btn flat :to="{ name: 'login' }" class="hidden-xs-only">{{
          $t("login")
        }}</v-btn>

        <v-btn
          flat
          color="secondary"
          :to="{ name: 'login' }"
          class="hidden-sm-and-up"
          style="min-width: 30px"
          ><v-icon>account_circle</v-icon></v-btn
        >
        <!--  <v-btn flat :to="{ name: 'register' }">{{ $t('register') }}</v-btn> -->
      </template>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'
import ToolbarSuche from '~/components/startseite/ToolbarSuche2.vue'
import ToolbarSuchbegriff from '~/components/startseite/ToolbarSuchbegriff.vue'
import ToolbarLeistungswitch from '~/components/startseite/ToolbarLeistungswitch.vue'

import ToolbarGemerkt from '~/components/startseite/ToolbarGemerkt.vue'
import ProgressBar from '~/components/ProgressBar.vue'

import ToolbarNachrichten from '~/components/startseite/ToolbarNachrichten.vue'

export default {
  props: {
    drawer: {
      required: true,
      default: null
    }
  },
  components: {
    ToolbarSuche,
    ToolbarSuchbegriff,
    ToolbarGemerkt,
    ToolbarNachrichten,
    ToolbarLeistungswitch,
    ProgressBar
  },
  data: () => ({
    appName: window.config.appName,
    busy: false,
    offsetTop: 0
  }),
  computed: {
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck'
    }),
    showToolbar: function () {
      // if (this.$store.state.route.name !== 'startseite' && this.authenticated)
      if (this.$store.state.route.name === 'startseite') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    toggleDrawer () {
      this.$emit('toggleDrawer')
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    },
    async logout () {
      this.busy = true
      if (this.drawer) {
        this.toggleDrawer()
      }
      await this.$store.dispatch('logout')
      this.busy = false
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="stylus" scoped>
.toolbar__title .router-link-active
  text-decoration: none
</style>
